"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWorkspace = void 0;
const app_1 = require("@koopajs/app");
const react_redux_1 = require("react-redux");
const useWorkspace = () => {
    const dispatchUpdateWorkspace = app_1.Operations.Workspaces.update(react_redux_1.useDispatch());
    const workspace = react_redux_1.useSelector(app_1.Selectors.Workspaces.getActiveWorkspace);
    const { errorMessage, isProcessing } = react_redux_1.useSelector(app_1.Selectors.Workspaces.state);
    const setWorkspace = async (attributes) => {
        return await dispatchUpdateWorkspace(workspace.id, attributes);
    };
    return {
        workspace,
        setWorkspace,
        errorMessage,
        isProcessing
    };
};
exports.useWorkspace = useWorkspace;
//# sourceMappingURL=useWorkspace.js.map